import ComponentHelper from '../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './test-runner-modal.css';
import Spinner from '../../components/spinner/Spinner';
import RoutingService from '../../services/RoutingService';
import JSONTree from 'react-json-tree';
import RESTService from '../../services/RESTService';

import { getStatusText } from 'http-status-codes';

const RS = new RoutingService();
const connect = new RESTService();

class TestRunnerModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		this.data = {
			title: `Test Results`,
			animationCls: 'zoomIn',
			tabs: ['results'],
			activeTab: 'results',
			statusCode: 0,
			codeText: '',
			testing: true,
			results: {}
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
			if (nextProps.isOpen) {
				this.runTest();
			}
		}
	}

	startAsyncRunner = () => {
		this.asyncRunner = setInterval(() => {
			connect
				.asyncEndpoint(this.data.ticketId)
				.then(res => {
					if (res.data.result) {
						this.observe(() => {
							this.data.results = res.data.result;
							if (res.data.result.status) {
								this.data.statusCode = Number(res.data.result.status);
								try {
									this.data.codeText = getStatusText(this.data.statusCode);
								} catch (err) {}
							} else {
								this.data.statusCode = 200;
								this.data.codeText = 'OK';
							}
							this.data.testing = false;
							if (this.data.results.headers && this.data.tabs.indexOf('Headers') <= 0) {
								this.data.tabs.push('Headers');
							}
						});
						clearInterval(this.asyncRunner);
					}
				})
				.catch(err => {
					this.observe(() => {
						this.data.results = err.response.data;
						this.data.statusCode = err.response.data.status;
						this.data.codeText = 'Error';
						this.data.testing = false;
					});
					clearInterval(this.asyncRunner);
				});
		}, 1500);
	};

	runTest = () => {
		this.observe(() => {
			this.data.testing = true;
			this.data.statusCode = 0;
		});
		if (this.props.async) {
			this.props
				.runTest()
				.then(res => {
					this.setData('ticketId', res.data.ticketId);
					this.startAsyncRunner();
				})
				.catch(err => {
					RS.smartError(err);
					this.observe(() => {
						this.data.results = err.response;
						if (this.data.results) {
							this.data.results = JSON.parse(JSON.stringify(err.response));
							if (this.data.results.status) {
								this.data.statusCode = Number(this.data.results.status);
								try {
									this.data.codeText = getStatusText(this.data.statusCode);
								} catch (err) {}
							}
						} else {
							this.data.results = {};
							this.data.results.body = err.message;
							this.data.statusCode = 400;
							this.data.codeText = 'Bad Request';
						}
						this.data.testing = false;
					});
				});
		} else {
			this.props
				.runTest()
				.then(res => {
					this.observe(() => {
						this.data.testing = false;
						if (res.data.result) {
							this.data.results = res.data.result;
							if (res.data.result.status) {
								this.data.statusCode = Number(res.data.result.status);
								try {
									this.data.codeText = getStatusText(this.data.statusCode);
								} catch (err) {}
							} else {
								this.data.statusCode = 200;
								this.data.codeText = 'OK';
							}
						}
						if (res.data.result.error) {
							this.data.results = JSON.parse(JSON.stringify(res.data.result.error));
						}
						if (res.data.result.headers && this.data.tabs.indexOf('Headers') <= 0) {
							this.data.tabs.push('Headers');
						}
					});
				})
				.catch(err => {
					RS.smartError(err);
					this.observe(() => {
						this.data.results = err.response;
						if (this.data.results) {
							this.data.results = JSON.parse(JSON.stringify(err.response));
							this.data.statusCode = Number(this.data.results.status);
							try {
								this.data.codeText = getStatusText(this.data.statusCode);
							} catch (err) {}
						} else {
							this.data.results = {};
							this.data.results.body = err.message;
							this.data.statusCode = 400;
							this.data.codeText = 'Bad Request';
						}
						this.data.testing = false;
					});
				});
		}
	};

	onClose = () => {
		if (this.asyncRunner) {
			clearInterval(this.asyncRunner);
		}
		this.setData('animationCls', 'zoomOut');
		setTimeout(() => {
			this.props.onClose();
		}, 250);
	};

	switchTab = evt => {
		this.setData('activeTab', evt.currentTarget.dataset.tab);
	};

	getTabs = () => {
		let tabs = [];
		for (let i = 0; i < this.data.tabs.length; i++) {
			let tab = this.data.tabs[i];
			tabs.push(
				<div
					className={`editor-tab vbox vcenter hcenter ellipse ${this.data.activeTab === tab ? 'active' : ''}`}
					data-tab={tab}
					onClick={this.switchTab}
					key={i}
				>
					{this.data.tabs[i]}
				</div>
			);
		}
		return tabs;
	};

	render() {
		let { isOpen } = this.props;
		let { title, animationCls, activeTab, testing, results, statusCode, codeText } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className={`test-runner-modal animated ${animationCls}`}
				overlayClassName="blur-modal-overlay vbox hcenter vcenter"
			>
				<div className="editor-container">
					<div className="editor-header hbox">
						<div className="title grow-1">{title}</div>
						<div className={`status-code ${statusCode === 200 ? 'green' : statusCode >= 400 ? 'red' : 'hidden'}`}>{`${statusCode} ${codeText}`}</div>
						<i className="mdi mdi-close" onClick={this.onClose} />
					</div>
					<div className="tab-ctn hbox vcenter hright">{this.getTabs()}</div>
					<div className="editor-content">
						{testing && <Spinner height="500px" text="Testing..." />}
						{!testing && activeTab === 'results' ? (
							<JSONTree data={results} />
						) : !testing && activeTab === 'Headers' ? (
							<JSONTree data={results.headers} />
						) : (
							''
						)}
					</div>
					<div className="btn-ctn">
						<button className="btn m-r-20" onClick={this.onClose}>
							Cancel
						</button>
						<button className="btn primary" onClick={this.runTest}>
							Run Again
						</button>
					</div>
				</div>
			</Modal>
		);
	}
}
export default TestRunnerModal;



// WEBPACK FOOTER //
// ./src/components/test-runner-modal/TestRunnerModal.js